var map = {
	"./distance-green.svg": "c11c",
	"./distance-indigo.svg": "1a4d",
	"./flash-green.svg": "71ce",
	"./flash-indigo.svg": "92fa",
	"./landscape-green.svg": "2bd4",
	"./landscape-indigo.svg": "5d65"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61c4";